import { render, staticRenderFns } from "./otherResource.vue?vue&type=template&id=09be4df1&scoped=true&"
import script from "./otherResource.vue?vue&type=script&lang=js&"
export * from "./otherResource.vue?vue&type=script&lang=js&"
import style0 from "./otherResource.vue?vue&type=style&index=0&id=09be4df1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be4df1",
  null
  
)

export default component.exports